import React from "react";

import { useViewport } from "@/contexts/ViewportContext";

import ListMobile from "./StoreList.mobile";
import ListWeb from "./StoreList.web";
import { StoreListProps } from "./types";

const StoreList = ({ data, isLoading, onLoadMore, onSelect }: StoreListProps) => {
  const { isWebMode } = useViewport();

  const Component = isWebMode ? ListWeb : ListMobile;

  return (
    <Component data={data} isLoading={isLoading} onLoadMore={onLoadMore} onSelect={onSelect} />
  );
};

export default StoreList;
